import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import Pasos from "./Pasos";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas",
  },
  {
    path: "/hotel",
    label: "Hotel",
    isActive: true,
  },
];

function ReservarHotel() {
  return (
    <Page
      title="Reserva de Hotel"
      description="Agendamiento de noches de hotel para mascota."
      breadCrumbs={breadCrumbs}
    >
      <Pasos />
    </Page>
  );
}

export default ReservarHotel;
